import React, { Component, Fragment } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import numeral from "../../../../node_modules/numeraljs/numeral.js";

import {
  MetricTable,
  sortNumeric,
  selectFormat,
  Error,
  truncate,
} from "../../Utils/Utils.js";

import missing_image from "./../../../i/missing_image.svg";

export const TableContentCell = (cell, row, rowIndex, board) => {
  // Image
  let IMAGE = { backgroundImage: `url(${missing_image})` };
  if (row.image_url == null) {
    IMAGE = { backgroundImage: `url(${missing_image})` };
  } else {
    IMAGE = { backgroundImage: `url(${row.image_url})` };
  }

  // Url
  let URL = row.url;
  let TARGET = "_blank";

  // Title
  let TITLE = "";
  if (row.title !== null) {
    TITLE = <h1 className="content-table__title">{truncate(row.title, 50)}</h1>;
  } else {
    TITLE = "";
  }

  const PUB_DATE = row.date_pub.date || false;

  return (
    <article className="content-table">
      <figure className="content-table__figure">
        {URL ? (
          <a href={URL} target={TARGET}>
            <div className="content-table__img" style={IMAGE} />
          </a>
        ) : (
          <div className="content-table__img" style={IMAGE} />
        )}
      </figure>

      <section className="content-table__detail">
        {URL ? (
          <a href={URL} target={TARGET}>
            {TITLE}
          </a>
        ) : (
          TITLE
        )}

        <time className="content-table__date">{PUB_DATE ? PUB_DATE : ""}</time>
      </section>
    </article>
  );
};

function metric(cell, row) {
  if (cell && cell.value === 0) {
    return (
      <span className="metric-table">
        <span className="metric-table__primary">
          {numeral(cell.value).format("0a")}
        </span>{" "}
        <span className="metric-table__new">new</span>
      </span>
    );
  }

  return <MetricTable {...cell} />;
}

const pagination = paginationFactory({
  sizePerPage: 15,
  hideSizePerPage: true,
});

const CustomToggleList = ({ onColumnToggle, toggles }) => {
  const toggleColumns = (columns) =>
    columns.map((col) => {
      return onColumnToggle(col);
    });

  return (
    <button
      type="button"
      className={`btn-toggle-columns${
        toggles["facebook_views"] ? "" : "--active"
      }`}
      onClick={() =>
        toggleColumns([
          "parsely_minutes",
          "youtube_minutes",
          "twitter_minutes",
          "facebook_minutes",
          "parsely_views",
          "youtube_views",
          "twitter_views",
          "facebook_views",
        ])
      }
    >
      View {toggles["facebook_views"] ? "Minutes" : "Views"}
    </button>
  );
};

class ViewsBySpeakingId extends Component {
  componentDidMount() {
    this.props.childRef(this);
    this.props.passRefUpward(this.childRef);
  }

  toggleButtonState = () => {
    this.setState({
      toggleMinutes: !this.state.toggleMinutes,
    });
  };

  renderTable(data) {
    const { cells, title: _title } = this.props;

    // add unique ids
    data.forEach((d, i) => (d.id = i));

    const columns = [
      {
        dataField: "title",
        text: "Title",
        style: { width: "280px", minWidth: "280px", textAlign: "left" },
        headerAlign: "left",
        formatter: TableContentCell,
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "parsely_series_speakingId",
        text: "Series",
        style: { width: "100px", minWidth: "100px" },
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "parsely_issue_speakingId",
        text: "Issue",
        style: { width: "140px", minWidth: "140px" },
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "parsely_views",
        text: "Parsely Views",
        style: { width: "100px", minWidth: "110px" },
        formatter: metric,
        csvFormatter: (cell) => selectFormat("number", cell && cell.value),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "youtube_views",
        text: "YoutTube Views",
        style: { width: "120px", minWidth: "120px" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "twitter_views",
        text: "Twitter Views",
        style: { width: "100px", minWidth: "100px" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "facebook_views",
        text: "Facebook Views",
        style: { width: "120px", minWidth: "120px" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "parsely_minutes",
        text: "Parsely Minutes",
        style: { width: "100px", minWidth: "110px" },
        formatter: metric,
        csvFormatter: (cell) => selectFormat("number", cell && cell.value),
        sort: true,
        sortFunc: sortNumeric,
        hidden: true,
      },
      {
        dataField: "youtube_minutes",
        text: "YoutTube Minutes",
        style: { width: "120px", minWidth: "120px" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
        hidden: true,
      },
      {
        dataField: "twitter_minutes",
        text: "Twitter Minutes",
        style: { width: "100px", minWidth: "100px" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
        hidden: true,
      },
      {
        dataField: "facebook_minutes",
        text: "Facebook Minutes",
        style: { width: "120px", minWidth: "120px" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
        hidden: true,
      },
    ];

    const defaultSorted = [
      {
        dataField: "parsely_views",
        order: "desc",
      },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }

    const filename = _title.split(" ").join("_") || "spreadsheet";

    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        columnToggle
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <Fragment>
            <CustomToggleList {...props.columnToggleProps} />
            <BootstrapTable
              defaultSorted={defaultSorted}
              filter={filterFactory()}
              pagination={pagination}
              {...props.baseProps}
              {...props.csvProps}
              ref={(el) => (this.childRef = el)}
            />
          </Fragment>
        )}
      </ToolkitProvider>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return this.renderTable(data.data);
  }
}

export default ViewsBySpeakingId;
